import { RouteObject } from "react-router-dom";
import { PageNotFound } from "../app/404";
import { ForgotPasswordPage } from "../app/auth/forgotPassword";
import { LoginPage } from "../app/auth/login";
import { ResetPasswordPage } from "../app/auth/resetPassword";
import { SignupPage } from "../app/auth/signup";
import { DiscountsPage } from "../app/discounts";
import { SingleDiscount } from "../app/discounts/singleDiscount";
import { ErrorPage } from "../app/error";
import { EventsPage } from "../app/events";
import { AddOrgPage } from "../app/events/addOrg";
import { AddPayoutPage } from "../app/events/addPayout";
import { EventForm } from "../app/events/form";
import { EventGuestsPage } from "../app/events/guests";
import { PreviewSingleEvent } from "../app/events/preview";
import { EventPublishedPage } from "../app/events/published";
import { ViewSingleEvent } from "../app/events/view";
import { ViewTicket } from "../app/events/viewTicket";
import { GuestViewTicket } from "../app/events/viewTicket/guest";
import { HomePage } from "../app/home";
import { GuestHomePage } from "../app/home/guest";
import { LegalPage } from "../app/legal";
import { PaymentSuccessPage } from "../app/payment/success";
import { Settings } from "../app/settings";
import { AppLayout } from "../components/layout/appLayout";
import { AuthLayout } from "../components/layout/authLayout";
import { Protected } from "../components/layout/protected";

export const router: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <AuthLayout>
            <LoginPage />
          </AuthLayout>
        ),
      },
      {
        path: "login",
        element: (
          <AuthLayout>
            <LoginPage />
          </AuthLayout>
        ),
      },
      {
        path: "signup",
        element: (
          <AuthLayout>
            <SignupPage />
          </AuthLayout>
        ),
      },
      {
        path: "forgot-password",
        element: (
          <AuthLayout>
            <ForgotPasswordPage />
          </AuthLayout>
        ),
      },
      {
        path: "reset-password",
        element: (
          <AuthLayout>
            <ResetPasswordPage />
          </AuthLayout>
        ),
      },
      {
        path: "complete-profile",
        element: (
          <AppLayout>
            <Protected>
              <AddOrgPage />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "event/new",
        element: <EventForm mode="create" />,
      },
      {
        path: "event/:slug/edit",
        element: <EventForm mode="edit" />,
      },
      {
        path: "event/:id/guests",
        element: <EventGuestsPage />,
      },
      {
        path: "home",
        element: (
          <AppLayout>
            <Protected>
              <HomePage />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "home/guest",
        element: (
          <AppLayout>
            <GuestHomePage />
          </AppLayout>
        ),
      },
      {
        path: "events/:index/ticket/guest",
        element: (
          <AppLayout>
            <GuestViewTicket />
          </AppLayout>
        ),
      },
      {
        path: "events/guest/:guestId/ticket",
        element: (
          <AppLayout>
            <Protected>
              <ViewTicket />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "events/:slug/published",
        element: (
          <AppLayout>
            <Protected>
              <EventPublishedPage />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "events/:id/add-payout",
        element: (
          <AppLayout>
            <Protected>
              <AddPayoutPage />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "events/:slug",
        element: (
          <AppLayout>
            <PreviewSingleEvent canBuy />
          </AppLayout>
        ),
      },
      {
        path: "events/:slug/preview",
        element: (
          <AppLayout>
            <PreviewSingleEvent canBuy={false} />
          </AppLayout>
        ),
      },
      {
        path: "events/:slug/details",
        element: (
          <AppLayout>
            <Protected>
              <ViewSingleEvent />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "events",
        element: (
          <AppLayout>
            <Protected>
              <EventsPage />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "settings",
        element: (
          <AppLayout>
            <Protected>
              <Settings />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "discounts",
        element: (
          <AppLayout>
            <Protected>
              <DiscountsPage />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "discounts/:discountCode",
        element: (
          <AppLayout>
            <Protected>
              <SingleDiscount />
            </Protected>
          </AppLayout>
        ),
      },
      {
        path: "payment/success",
        element: (
          <AppLayout>
            <PaymentSuccessPage />
          </AppLayout>
        ),
      },
      {
        path: "legal/:doc",
        element: (
          <AppLayout>
            <LegalPage />
          </AppLayout>
        ),
      },
      {
        path: "404",
        element: (
          <AppLayout>
            <PageNotFound />
          </AppLayout>
        ),
      },
    ],
  },

  {
    path: "*",
    element: (
      <AppLayout>
        <PageNotFound />
      </AppLayout>
    ),
  },
];
